module.exports = __webpack_public_path__ + "img/spartan-sheetrock-framing-texture-03-square.60d90ecb.jpg";